import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useToast } from "@/shared/providers/ToastProvider";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { downloadAdminBackup } from "../api/adminOpsApi";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { isSuperAdminUser } from "../auth";

export function CreateBackupPage() {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  if (!isSuperAdminUser()) {
    return <Navigate to="/dashboard/admin" replace />;
  }

  const handleExport = async () => {
    setLoading(true);
    try {
      await downloadAdminBackup();
      showToast({ message: t.safecheck.system.backup.exportSuccess, variant: "success" });
    } catch (error) {
      showToast({
        message: error instanceof Error ? error.message : t.safecheck.system.backup.exportSuccess,
        variant: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumbs homeHref="/dashboard/admin" items={[{ label: t.safecheck.nav.backup }]} />

      <div className="theme-card p-6">
        <p className="text-sm text-muted">{t.safecheck.system.backup.exportInstruction}</p>
        <button
          type="button"
          onClick={handleExport}
          disabled={loading}
          className="mt-5 rounded-lg bg-purple px-5 py-2.5 text-sm font-medium text-white shadow-[var(--shadow-sm)] transition-colors hover:bg-purple/90 disabled:opacity-60"
        >
          {loading ? "…" : t.safecheck.system.backup.exportButton}
        </button>
      </div>
    </>
  );
}
